import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { TaxResult } from '../../models/taxResult';

@Component({
  standalone: false,
  selector: 'gstar-explanation-field',
  templateUrl: './explanation-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExplanationFieldComponent {
  taxResultItem: InputSignal<TaxResult[]> = input.required<TaxResult[]>();

  transactionTypeName: Signal<string> = computed(
    () => this.taxResultItem()[0].transactionTypeName ?? ''
  );

  explanation: Signal<string> = computed(
    () => cloneDeep(this.taxResultItem()).reverse()[0].description ?? ''
  );

  multipleRatesString(item: TaxResult[]): string {
    if (item.length > 0) {
      return item.map((value: TaxResult) => value.rate).join('%, ');
    }
    return '';
  }
}
